import { useAppNavigation } from "@/features/Navigation/hooks/useAppNavigation";
import { enable_promptbook_onboarding_flag } from "@/services/posthog/feature_flags";
import { Button, Divider, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { Icon } from "@pufflig/prompt-studio-ui";
import { useFeatureFlagEnabled } from "posthog-js/react";

interface HelpButtonProps {
  showOnboarding: boolean;
  onToggleOnboarding: () => void;
}

export const HelpButton = (props: HelpButtonProps) => {
  const { navigateToDiscord, navigateToDocumentation } = useAppNavigation();
  const { showOnboarding, onToggleOnboarding } = props;
  const isOnboardingEnabled = useFeatureFlagEnabled(enable_promptbook_onboarding_flag);
  return (
    <Menu>
      <MenuButton
        className="help_button"
        as={Button}
        position="absolute"
        right="1rem"
        bottom="1rem"
        color="foreground.inverse"
        background="foreground.primary"
        paddingRight={"0"}
        paddingLeft="0"
        textAlign="center"
        width="2rem"
        height="2rem"
        textStyle="label/L/medium"
        borderRadius={"2rem"}
        aria-label="Help"
        fontSize={"1rem"}
        _hover={{
          background: "foreground.primary",
          color: "foreground.inverse",
          border: "1px solid",
        }}
        _active={{
          background: "foreground.primary",
          color: "foreground.inverse",
          border: "1px solid",
        }}
        size="sm"
      >
        ?
      </MenuButton>
      <MenuList>
        {isOnboardingEnabled && (
          <>
            <MenuItem
              onClick={() => {
                onToggleOnboarding();
              }}
            >
              {showOnboarding ? "Disable Onboarding" : "Reset Onboarding"}
            </MenuItem>
            <Divider my="1" />
          </>
        )}
        <MenuItem
          gap="1"
          display="flex"
          onClick={() => {
            navigateToDocumentation();
          }}
        >
          <Icon name="document-text-1" />
          Documentation
        </MenuItem>
        <MenuItem
          gap="1"
          display="flex"
          onClick={() => {
            navigateToDiscord();
          }}
        >
          <Icon name="sms" />
          Contact Us
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
